import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useIntl } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { ProductDetailSpecificationContainer } from '../../../Components/ProductDetailSpecification/ProductDetailSpecificationContainer.js';
import { getContactLensFeatures } from '../../utils/get-contactlens-features.js';

const LensesSpecification = ()=>{
    const { getLabel  } = useIntl();
    const { activeVariant  } = useProductDetailContext();
    const { productFeatures  } = React.useMemo(()=>CommerceToolsApi.isLenses(activeVariant) ? getContactLensFeatures(activeVariant, getLabel) : {
            productFeatures: []
        }
    , [
        getLabel,
        activeVariant
    ]);
    return /*#__PURE__*/ React.createElement(ProductDetailSpecificationContainer, {
        fallbackConfiguration: productFeatures
    });
};

export { LensesSpecification };
//# sourceMappingURL=LensesSpecification.js.map
